module.exports = "query GetFairUseMarketingContent {\n  fairUsePolicyLink: marketingUrl(title: \"FairUsePolicyLink\") {\n    __typename\n    url\n  }\n}\n"